import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('here');
    this.element.addEventListener("click", (event) => this.toggleActive(event));
  }

  disconnect() {
    this.element.removeEventListener("click", (event) => this.toggleActive(event));
  }

  toggleActive(event) {
    event.preventDefault();  // prevent the default action if you don't want the page to reload or navigate

    // Remove the 'active' class from all list-group-items
    this.element.querySelectorAll(".list-group-item").forEach((item) => {
      item.classList.remove("active");
    });

    // Add the 'active' class to the clicked list-group-item
    event.target.classList.add("active");
  }
}
